export default "__VITE_ASSET__48ce6e23__"